var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FirstPage',{attrs:{"section":11,"audio":true}},[_c('p',[_vm._v("Did you know that there are "+_vm._s(_vm.stepsOrder.length)+" steps to using a condom the right way?")])])}
var staticRenderFns = []

export { render, staticRenderFns }